import React from 'react';

type DashboardStatCardProps = {
  label: string;
  value: string;
  /** Zweite Zeile unter dem Wert, z. B. das Volumen zur Anzahl. */
  detail?: string;
  caption?: string;
};

/** Kennzahl ohne Zeitraumvergleich (aktueller Bestand), im Stil von DashboardKpiCard. */
export function DashboardStatCard({ label, value, detail, caption = 'Aktueller Bestand' }: DashboardStatCardProps) {
  return (
    <div className="rounded-xl border border-app-border bg-app-surface p-4 shadow-sm">
      <p className="text-xs font-semibold text-app-text-subtle">{label}</p>
      <p className="mt-2 text-2xl font-bold text-app-text">{value}</p>
      {detail ? <p className="mt-0.5 text-xs font-medium text-app-text-muted tabular-nums">{detail}</p> : null}
      <p className="mt-1 text-xs text-slate-400">{caption}</p>
    </div>
  );
}
